import { helper } from '@ember/component/helper';

/**
 * Converts SCREAMING_SNAKE_CASE or kebab-case to Title Case.
 * Passes through values that are already human-readable.
 *
 * {{humanize "FULL_TIME"}} → "Full Time"
 * {{humanize "PART_TIME"}} → "Part Time"
 * {{humanize "already readable"}} → "Already Readable"
 */
export function humanize(value: string): string {
  if (!value) return '';

  return value
    .replace(/[_-]/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export default helper(function ([value]: [string]) {
  return humanize(value);
});
